import React from 'react';

function HowItWorks() {
  const items = [
    {
      title: 'Join the Club',
      text: 'Sign up as a shareholder by making a modest monthly contribution, which is added to our communal investment fund.',
      image: '/106230_add_icon.png',
    },
    {
      title: 'Pool Capital',
      text: "Every month, members contribute to grow the Club's overall capital, enabling larger and more diverse investments than individuals could pursue alone.",
      image: '/manual-transfer-of-fund-pool.png',
    },
    {
      title: 'Vote & Decide',
      text: 'Each share equals one vote. Major decisions; like buying property, investing in an IPO, or allocating funds to Bitcoin etc., require a majority vote. You always have a say in our collective future.',
      image: '/vecteezy_cast-vote-black-icon-hand-icon-holding-ballot-paper_8506396.png',
    },
    {
      title: 'Monitor & Grow',
      text: 'Our Manager oversees day-to-day activities, but we continuously share updates, performance reports, and insights so you know how your money is working.',
      image: '/diagram.png',
    },
    {
      title: 'Reap the Benefits',
      text: 'Over time, Club assets appreciate, dividends will be distributed, or gains realized upon exit events, benefiting every member in line with their shareholding.',
      image: '/incentive.png',
    },
  ];

  return (
    <section
      id="how-it-works"
      style={{
        padding: '5rem 1rem',
        background: 'linear-gradient(45deg, #e6f0fa, #f0f9e8, #fff5e6)',
        backgroundSize: '400% 200%',
        animation: 'gradientShift 20s ease infinite',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2
          style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#1F1F1F',
            marginBottom: '3rem',
            textAlign: 'center',
            animation: 'fadeIn 1s ease-in-out',
          }}
        >
          How We Operate
          <div
            style={{
              width: '5rem',
              height: '0.375rem',
              backgroundColor: '#D69E2E',
              margin: '1rem auto 0',
              borderRadius: '0.25rem',
            }}
          ></div>
        </h2>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '2rem',
            position: 'relative',
          }}
        >
          {items.map((item, index) => (
            <div
              key={index}
              style={{
                backgroundColor: '#fff',
                padding: '1.5rem',
                borderRadius: '1rem',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                position: 'relative',
                width: 'calc(20% - 2rem)',
                minWidth: '250px',
                flex: '1 1 250px',
                maxWidth: '300px',
                height: '320px', // Reduced from 400px to 320px
                display: 'flex',
                flexDirection: 'column',
                opacity: 0,
                transform: 'translateY(30px) rotateY(-15deg)',
                animation: `cardPop 0.8s ease-out ${index * 0.2}s forwards`,
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.03) rotateY(0deg)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1) rotateY(0deg)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div
                style={{
                  width: '5rem', // Reduced from 6rem to 5rem
                  height: '5rem', // Reduced from 6rem to 5rem
                  backgroundColor: '#FEF3C7',
                  borderRadius: '50%',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease',
                  flexShrink: 0
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector('img').style.transform = 'scale(1.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector('img').style.transform = 'scale(1)';
                }}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: '2.5rem', // Reduced from 3rem to 2.5rem
                    height: '2.5rem', // Reduced from 3rem to 2.5rem
                    objectFit: 'contain',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h3
                  style={{
                    fontSize: '1.15rem', // Reduced from 1.25rem to 1.15rem
                    fontWeight: '700',
                    marginBottom: '0.75rem', // Reduced from 1rem to 0.75rem
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    fontSize: '0.95rem', // Reduced from 1rem to 0.95rem
                    color: '#4B5563',
                    lineHeight: '1.5', // Reduced from 1.6 to 1.5
                    flex: 1,
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {item.text}
                </p>
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '0.5rem',
                  background: 'linear-gradient(90deg, #FFC300, #D69E2E)',
                  opacity: 0.8,
                }}
              ></div>
            </div>
          ))}
        </div>

        <div
          style={{
            textAlign: 'center',
            marginTop: '4rem',
            animation: 'fadeIn 2s ease-in-out',
          }}
        >
          <a
            href="https://t.me/AICUAE"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#1F1F1F',
              color: '#FFFFFF',
              padding: '1rem 2rem',
              borderRadius: '0.75rem',
              fontSize: '1.125rem',
              fontWeight: '700',
              textDecoration: 'none',
              animation: 'pulse 2s infinite',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#333333';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 8px 15px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#1F1F1F';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Become a Shareholder
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 1100px) {
          div[style*="width: calc(20% - 2rem)"] {
            width: calc(33.333% - 2rem) !important;
            max-width: none;
          }
          
          h2 {
            font-size: 1.75rem;
          }
          h3 {
            font-size: 1.125rem;
          }
          p {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 768px) {
          div[style*="width: calc(20% - 2rem)"] {
            width: 100% !important;
            max-width: 350px;
          }
        }

        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(-10px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        @keyframes cardPop {
          0% {
            opacity: 0;
            transform: translateY(30px) rotateY(-15deg);
          }
          60% {
            opacity: 1;
            transform: translateY(-10px) rotateY(5deg);
          }
          100% {
            opacity: 1;
            transform: translateY(0) rotateY(0deg);
          }
        }

        @keyframes pulse {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3); }
          50% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(0, 0, 0, 0); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); }
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </section>
  );
}

export default HowItWorks;